import { render, staticRenderFns } from "./new.page.vue?vue&type=template&id=be451fd8&scoped=true"
import script from "./new.page.vue?vue&type=script&lang=js"
export * from "./new.page.vue?vue&type=script&lang=js"
import style0 from "./new.page.vue?vue&type=style&index=0&id=be451fd8&prod&lang=scss&scoped=true"
import style1 from "./new.page.vue?vue&type=style&index=1&id=be451fd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be451fd8",
  null
  
)

export default component.exports